import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

export const mcpServersQueryKey = (orgId: string | undefined) => [
  "mcpServers",
  orgId,
];

export function useMcpServers(orgId: string | undefined) {
  const { mcpRegistryService } = useDomainServices();

  return useQuery({
    queryKey: mcpServersQueryKey(orgId),
    queryFn: ({ signal }) =>
      mcpRegistryService.listServers(orgId!, { abortSignal: signal }),
    enabled: orgId !== undefined,
    staleTime: 60_000,
  });
}
